<template>
	<!-- 图片选择 -->
	<div @click="setEditIndex(index)">
		<span v-if="isBankViewTest" class="my-bank-tag">{{$t('main.PictureSelection')}}</span>
		<el-row :gutter="10" class="question-box">
			<el-col v-if="!isBankViewTest" :xs="1" :sm="1" :md="1" :lg="1" :xl="1" class="askxh">
				{{ question.quesIndex + 1 }}
			</el-col>
			<el-col :xs="15" :sm="15" :md="15" :lg="15" :xl="15" class="item_container_title" @click="setActiveInput(question.qid)">
				
        		<span style="lineHeight: 30px" v-if="isBankViewTest && question.questionsName">{{question.questionsName}}</span>
				<TitleEditor 
          			:isTest="true"
					v-if="!isBankViewTest" 
					class="outline-none" 
					:qid="question.qid" 
					:class="question.qid"  
					:value="question.questionsName" 
                    :actionTitleEditorShow="activeInputId === question.qid"
					@childValueChange="val=>{ question.questionsName = val }" 
				></TitleEditor>
			</el-col>
			<el-col class="setBtn-box" :xs="7" :sm="7" :md="7" :lg="7" :xl="7" v-if="!$route.query.index">
				<OperateWrap
					style="display: flex;
						width: 100%;
						justify-content: end;
					"
					:bankId="$route.query.bankId"	
					:question="question"
				></OperateWrap>
			</el-col>
		</el-row>
		<div style="margin-left:47px" class="option-box">
			<div class="upload_box" v-if="!isBankViewTest">
				<div class="upload_box_i">
					<el-upload
						class="avatar-uploader"
						:action="$config.service.uploadApi"
						accept="image/jpeg,image/png"
						:show-file-list="false"
						:on-success="handleSuccess"
						:before-upload="beforeAvatarUpload"
						:data="QiniuData"
						:on-remove="handleRemove"
						multiple
						:limit="limit"
					>
						<i class="el-icon-plus avatar-uploader-icon"></i>
					</el-upload>
					<p class="img-tip">{{$t('main.Upload1SheetAtATime')}}</p>
					<p class="img-tip">{{$t('main.UpTo10CopiesCanBeUploaded')}}</p>
				</div>
			</div>
			<draggable class="drag-container" v-model="question.optionList">
      			<transition-group class="img-box" tag="div" type="transition" :name="'flip-list'">
					<template
						style="margin-top: 12px !important;margin-bottom:20px;margin-right:10px;width:146px;"
						v-for="(childItem, childindex) in question.optionList"
					>
						<div
							class="option-item"
							:key="index + '_' + childindex" 
							@click="setEditOptionIndex(childindex)" 
							style="width:146px;"
						>
							<div class="img_box">
								<img :src="childItem.optionImgUrl" alt="" />
								<div class="radio-optino" >
									<div class="radio" v-if="question.cutType == 7"></div>
									<div class="checkbox" v-if="question.cutType == 8"></div>
									<div @click="setActiveInput(childItem.oid)">
										<span v-if="isBankViewTest">{{childItem.labelName}}</span>
										<TitleEditor 
											v-if="!isBankViewTest" 
											class="outline-none" 
											:qid="childItem.oid" 
											:class="childItem.oid"  
											:value="childItem.labelName" 
                							:actionTitleEditorShow="activeInputId === childItem.oid"
											@childValueChange="(val) => labelNameChange(val, childItem)" 
										></TitleEditor>
									</div>
								</div>
								<div class="edit">
									<!-- <p> -->
										<p id="uploadImg">
											<input type="file" id="file" size="1" accept="image/*" @change="filechange($event, childItem.oid)" />
											<a href="#">{{$t('main.modify')}}</a>
										</p>
									<!-- </p> -->
									<p class="deleteBtn" @click="wjdelquestionoption(childItem.oid, childindex)">{{$t('main.delete')}}</p>
								</div>
							</div>
						</div>
					</template>
				 </transition-group>
    		</draggable>
			<p class="clear"></p>
			
		</div>
	</div>
</template>
<script>
import OperateWrap from "./collectToBank/operateaWrap.vue"
import $ from 'jquery';
import { v1 as UUID } from "uuid";
// import DragMixin from "./DragMixin";
import TitleEditor from "@/components/titleEditor/titleEditor.vue"
import { mapActions, mapState } from "vuex"
export default {
	components: {
    	TitleEditor,
		OperateWrap
	},
	// inject: ['reload'],
 	//  mixins:[DragMixin],
	data() {
		return {
			limit: 10,
			editOptionIndex: '0_0',
			dialogImageUrl: '',
			dialogVisible: false,
			radio: '1',
			QiniuData: {
				biz: 'upDataWj',
				data: {}
			},
			uploadPicUrl: '', //提交到后台图片地址
			fileList: [],
			ImgList: [],
			radioValue: '',
			checkboxValue: [],
		};
	},
	props: {
		question: {},
		editIndex: { type: Number, default: 0 },
		isExistPage: { type: Boolean, default: false },
		index: { type: Number, default: 0 },
		// 管理题库时查看试题 只可以删除
		isBankViewTest: {
			type: Boolean,
			default: false
		},
	},
	computed: {
        ...mapState(['headers', 'activeInputId']),
	},
	created() {
	},
	methods: {
		...mapActions(['setActiveInput']),
		labelNameChange(val, option) {
			option.labelName = val
		},
		filechange(item, id) {
			var formData = new FormData();
			formData.append('file', item.target.files[0])
			formData.append('biz', 'upDataWj')
			var thit = this;
			$.ajax({
				url: `${this.$config.service.uploadApi}`,
				type: 'POST',
				data: formData,
				miniType: 'multipart/form-data',
				/**
				 *必须false才会自动加上正确的Content-Type
				 */
				contentType: false,
				/**
				 * 必须false才会避开jQuery对 formdata 的默认处理
				 * XMLHttpRequest会对 formdata 进行正确的处理
				 */
				processData: false,
				success: function(data) {
					// console.log('上传成功：文件访问地址：');
					// console.log(data)
					thit.xiugai(id, data.message);
				},
				error: function() {
					alert(thit.$t('main.UploadFailed'));
				}
			});
		},
		xiugai(id, imgUrl) {
			if (this.question != null && this.question.optionList.length > 0) {
				this.question.optionList.forEach((info,i) => {
					if (info.oid == id) {
						info.optionImgUrl = imgUrl
						info.labelName = imgUrl.split('upDataWj/')[1]
					}
				})
			}
			// console.log(this.question.optionList)
		},
		handleSuccess(res, file, fileList) {
			this.question.optionList.push(
				{
					labelName: file.name,
					optionImgUrl: file.response.message,
					oid: UUID()
				}
			)
		},
		handlePictureCardPreview(file) {
			this.dialogImageUrl = file.url;
			this.dialogVisible = true;
		},
		wjupdoption(item) {
			this.$emit('wjupdoption', item);
		},
		wjaddquestionoption(optionList, item, type = 1) {
			this.$emit('wjaddquestionoption', optionList, item, type);
		},
		setEditIndex(index) {
			// console.log(index)
			this.$emit('setEditIndex', index);
		},
		setEditOptionIndex(childIndex) {
			this.editOptionIndex = this.editIndex + '_' + childIndex;
		},
		wjdelquestionoption(oid, index) {
      		this.$emit("wjdelquestionoption", { qid: this.question.qid, oid }, index,)
		},
		handleRemove() {
			this.uploadPicUrl = '';
		},
		handleExceed() {
			this.$message.warning(this.$t('main.CurrentLimitSelection'));
		},
		beforeAvatarUpload(file) {
			this.QiniuData.data = file
			// this.QiniuData.key = `${file.name}`;
			// console.log(this.QiniuData)
		}
	}
};
</script>

<style scoped lang="scss">
/deep/.img_box .el-input__inner {
	width: 100px !important;
}
.img_box {
	width: 146px;
    min-height: 220px;
    border: 1px solid #ebeef5;
    position: relative;
    border-radius: 4px;
}
.img_box img {
	width: 146px;
	height: 146px;
}
.img_box:hover .edit {
	display: flex;
	width: 100%;
}
.edit {
	position: absolute;
	display: none;
	left: 0;
	bottom: 0;
	padding-bottom: 5px;
	background-color: rgba(204,204,204,.9);
	p{
		margin-top: 7px !important;
		color: #666;
		width: 73px;
		font-size: 12px;
		// float: left;
		text-align: center;
		a{
			color: #666;
		}
	}
}
#uploadImg {
	font-size: 12px;
	input{
		cursor: pointer;
		width: 24px;
		height: 16px;
	}
}
#file {
	position: absolute;
	z-index: 2;
	font-size: 60px;
	opacity: 0;
	filter: alpha(opacity=0);
}
/* .xiu{
        width:73px;
        font-size:12px;
        text-align:center;
    } */
p {
	text-align: center;
	color: #ccc;
	margin-top: 12px;
}
.upload_box_i {
	border: 1px dashed #ccc;
	border-radius: 4px;
}
.upload_box {
	display: inline-block;
	width: 146px;
	height: 220px;
	float: left;
	margin: 10px 10px 20px 10px;
}
.drag-container,
.option-item
{
	display: inline-block;
}
.option-item{
	margin: 10px 5px 0 5px;
}
/deep/.el-icon-plus {
	font-size: 75px !important;
	color: #ccc;
	margin-left: 35px;
	margin-top: 35px;
}
.upload_box_i {
	width: 146px;
	height: 220px;
}
.item .el-badge__content.is-fixed{top:10px;}
.item.drag-handle{
  cursor: move;
}
.el_item_option {
	line-height: 40px;
	// height: 44px;
}
.el-icon-common {
	margin-right: 23px;
	font-size: 16px !important;
	line-height: 40px !important;
	color: cornflowerblue;
	cursor: pointer;
}
.el-icon-common-option {
	margin-left: 10px;
	font-size: 22px !important;
	line-height: 40px !important;
	color: cornflowerblue;
	cursor: pointer;
}
.item_container_title {
	padding-left: 0px !important;
	padding-right: 0px !important;
}
.deleteBtn{
	cursor: pointer;
}
.radio-optino{
	margin-left: 15px;
    margin-top: 10px;
    display: flex;
	.radio::after{
		content: "";
		display: inline-block;
		border: 1px solid #dcdfe6;
		border-radius: 100%;
		width: 14px;
		height: 14px;
		background-color: #fff;
		cursor: pointer;
		box-sizing: border-box;
		margin-top: 8px;
		margin-right: 3px;
	}
	.checkbox::after{
		content: "";
		display: inline-block;
		border: 1px solid #dcdfe6;
		border-radius: 2px;
		width: 14px;
		height: 14px;
		background-color: #fff;
		cursor: pointer;
		box-sizing: border-box;
		margin-top: 8px;
		margin-right: 3px;
	}
}
.clear{
	height:0px;
	font-size:0;
	clear:both;
}
.img-tip{
	font-size: 12px;
}
</style>
